export default class IndicadoresDetailsController {
  constructor(AuthenticationService, UIService, IndicadoresService) {
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.IndicadoresService = IndicadoresService;

    this.anos = this.IndicadoresService.getAnos();

    // Get last year by default


    this.auxAno = {
      selected: this.anos.find(x => x.ano === (Number(moment().format('YYYY')) - 1)), // By default, always use last year
      infiniteScroll: {numToAdd: 20, currentItems: 20}
    };
    this.ano = null;

    this.loaded = true;

    this.quadrosHeadings = [
      "Quadro 1 — Promoting scientific excellence",
      "Quadro 2 — Promoting collaboration and interdisciplinary research",
      "Quadro 3 — Promoting responsible research and innovation",
      "Quadro 4 — Delivering of education and training",
      "Quadro 5 — Enhancing international collaboration and co-operation",
      "Quadro 6 — Promoting research impact on society including the contribution to SDGs",
      "Quadro 7 — Fostering outreach to the public",
      "Quadro 8 — Promoting the vitality and sustainability of the research environment",
      "Quadro 9 — Managing for the sustained success of the organization"
    ];
    this.quadrosIndex = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    this.quadros = [null, null, null, null, null, null, null, null, null];
    this.quadrosLoading = [false, false, false, false, false, false, false, false, false];
    this.quadrosErrors = [false, false, false, false, false, false, false, false, false];

    this.onAnoSelected(this.auxAno.selected);
  }

  // Called when year was selected
  onAnoSelected = (item) => {
    if (this.ano !== item.ano) {
      this.ano = item.ano;
      this.updateQuadros();
    } else {
      // Do nothing since year did not change
    }
  };

  // Called when we want to update all quadros (asyncronously)
  updateQuadros = () => {
    // Get all Quadros async
    for (let i = 0; i < this.quadrosIndex.length; i++) {
      this.quadrosLoading[i] = true;
      this.IndicadoresService.getQuadro(i, this.ano).then(data => {
        this.quadros[i] = data;
        this.quadrosErrors[i] = false;
        this.quadrosLoading[i] = false;
      }).catch(() => {
        this.quadros[i] = null;
        this.quadrosErrors[i] = true;
        this.quadrosLoading[i] = false;
      });
    }
  };

  // Return true if any quadro is loading, false otherwise
  isLoadingQuadros = () => this.quadrosLoading.reduce((a, c) => a || c, false);

  // Parse multivalue from Quadros to present in an array
  getObjectKeys = (object) => Object.keys(object);

}

IndicadoresDetailsController.$inject = ['AuthenticationService', 'UIService', 'IndicadoresService'];
